function _mergeNamespaces(n, m) {
  m.forEach(function (e) {
    e && typeof e !== 'string' && !Array.isArray(e) && Object.keys(e).forEach(function (k) {
      if (k !== 'default' && !(k in n)) {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  });
  return Object.freeze(n);
}

/**
 * Yle Design System
 * v0.4.0
 */

var border = {
  BORDER_SM: '1px',
  BORDER_MD: '2px'
};

var border$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': border
}, [border]);

/**
 * Yle Design System
 * v0.4.0
 */

var borderRadius = {
  NONE: 0,
  MEDIUM: '4px',
  LARGE: '8px',
  FULL: '400px'
};

var borderRadius$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': borderRadius
}, [borderRadius]);

/**
 * Yle Design System
 * v0.4.0
 */

var colors = {
  WHITE: '#ffffff',
  BLACK: '#000000',
  GRAY_5: '#f8f9fa',
  GRAY_10: '#f1f2f4',
  GRAY_20: '#e8e9eb',
  GRAY_30: '#d8d9db',
  GRAY_40: '#b4b6b7',
  GRAY_50: '#949697',
  GRAY_60: '#4a4f54',
  GRAY_70: '#323639',
  GRAY_80: '#292b2d',
  GRAY_90: '#1f2123',
  GRAY_95: '#131415',
  RED_5: '#fff5f8',
  RED_10: '#fcc5d3',
  RED_20: '#f99fb5',
  RED_30: '#f77898',
  RED_40: '#f5517a',
  RED_50: '#e90e43',
  RED_60: '#d10b3d',
  RED_70: '#9a092d',
  RED_80: '#740722',
  RED_90: '#4d0417',
  GREEN_5: '#e5fff9',
  GREEN_10: '#a1f9dd',
  GREEN_20: '#62f9c2',
  GREEN_30: '#1ff0a4',
  GREEN_40: '#03e592',
  GREEN_50: '#07ca84',
  GREEN_60: '#06b173',
  GREEN_70: '#058657',
  GREEN_80: '#046240',
  GREEN_90: '#023b26',
  BRAND: '#00b4c8',
  BLUE_5: '#e0f2ff',
  BLUE_10: '#c0ddf5',
  BLUE_20: '#9fc8ee',
  BLUE_30: '#88b3e7',
  BLUE_40: '#669de1',
  BLUE_50: '#2975d0',
  BLUE_60: '#1163b0',
  BLUE_70: '#234c93',
  BLUE_80: '#0a3276',
  BLUE_90: '#00284e',
  PURPLE_5: '#fcf5ff',
  PURPLE_10: '#e8d0f1',
  PURPLE_20: '#d9b0e8',
  PURPLE_30: '#ca91de',
  PURPLE_40: '#ba72d5',
  PURPLE_50: '#9436b5',
  PURPLE_60: '#80259f',
  PURPLE_70: '#620579',
  PURPLE_80: '#4b075b',
  PURPLE_90: '#30063a',
  YELLOW_5: '#fffce2',
  YELLOW_10: '#fcf0c5',
  YELLOW_20: '#fae69e',
  YELLOW_30: '#f9dc77',
  YELLOW_40: '#f7d350',
  YELLOW_50: '#f4c722',
  YELLOW_60: '#dab013',
  YELLOW_70: '#b18e0c',
  YELLOW_80: '#725a07',
  YELLOW_90: '#493b06',
  TURQUOISE_5: '#e5fdff',
  TURQUOISE_10: '#c7f4fa',
  TURQUOISE_20: '#9cebf4',
  TURQUOISE_30: '#5ddbe9',
  TURQUOISE_40: '#29ccde',
  TURQUOISE_50: '#00b4c8',
  TURQUOISE_60: '#009cb5',
  TURQUOISE_70: '#00809c',
  TURQUOISE_80: '#00637d',
  TURQUOISE_90: '#00475e',
  TURQUOISE_95: '#0b3f4b',
  ORANGE_5: '#fff3e2',
  ORANGE_10: '#ffe1b8',
  ORANGE_20: '#ffce8b',
  ORANGE_30: '#ffb95f',
  ORANGE_40: '#ff9c31',
  ORANGE_50: '#ff8f33',
  ORANGE_60: '#f1722a',
  ORANGE_70: '#e65a27',
  ORANGE_80: '#e04312',
  ORANGE_90: '#c93c11',
  BLACK_OPACITY_5: 'rgba(0, 0, 0, 0.02)',
  BLACK_OPACITY_10: 'rgba(0, 0, 0, 0.05)',
  BLACK_OPACITY_20: 'rgba(0, 0, 0, 0.09)',
  BLACK_OPACITY_30: 'rgba(0, 0, 0, 0.15)',
  BLACK_OPACITY_40: 'rgba(0, 0, 0, 0.29)',
  BLACK_OPACITY_50: 'rgba(0, 0, 0, 0.41)',
  BLACK_OPACITY_60: 'rgba(0, 0, 0, 0.7)',
  BLACK_OPACITY_70: 'rgba(0, 0, 0, 0.79)',
  BLACK_OPACITY_80: 'rgba(0, 0, 0, 0.83)',
  BLACK_OPACITY_90: 'rgba(0, 0, 0, 0.87)',
  BLACK_OPACITY_95: 'rgba(0, 0, 0, 0.92)',
  WHITE_OPACITY_5: 'rgba(255, 255, 255, 0.08)',
  WHITE_OPACITY_10: 'rgba(255, 255, 255, 0.13)',
  WHITE_OPACITY_20: 'rgba(255, 255, 255, 0.17)',
  WHITE_OPACITY_30: 'rgba(255, 255, 255, 0.21)',
  WHITE_OPACITY_40: 'rgba(255, 255, 255, 0.3)',
  WHITE_OPACITY_50: 'rgba(255, 255, 255, 0.59)',
  WHITE_OPACITY_60: 'rgba(255, 255, 255, 0.71)',
  WHITE_OPACITY_70: 'rgba(255, 255, 255, 0.85)',
  WHITE_OPACITY_80: 'rgba(255, 255, 255, 0.91)',
  WHITE_OPACITY_90: 'rgba(255, 255, 255, 0.95)',
  WHITE_OPACITY_95: 'rgba(255, 255, 255, 0.98)'
};

var colors$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': colors
}, [colors]);

/**
 * Yle Design System
 * v0.4.0
 */

var shadowDark = {
  SHADOW_SM: '0 0 8px 0 rgba(0, 0, 0, 0.70)',
  SHADOW_MD: '0 0 16px 0 rgba(0, 0, 0, 0.70)',
  SHADOW_LG: '0 0 24px 0 rgba(0, 0, 0, 0.87)'
};

var shadowDark$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': shadowDark
}, [shadowDark]);

/**
 * Yle Design System
 * v0.4.0
 */

var shadowDefault = {
  SHADOW_SM: '0 0 8px 0 rgba(0, 0, 0, 0.15)',
  SHADOW_MD: '0 0 16px 0 rgba(0, 0, 0, 0.15)',
  SHADOW_LG: '0 0 24px 0 rgba(0, 0, 0, 0.41)'
};

var shadowDefault$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': shadowDefault
}, [shadowDefault]);

/**
 * Yle Design System
 * v0.4.0
 */

var shadowLight = {
  SHADOW_SM: '0 0 8px 0 rgba(0, 0, 0, 0.15)',
  SHADOW_MD: '0 0 16px 0 rgba(0, 0, 0, 0.15)',
  SHADOW_LG: '0 0 24px 0 rgba(0, 0, 0, 0.41)'
};

var shadowLight$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': shadowLight
}, [shadowLight]);

/**
 * Yle Design System
 * v0.4.0
 */

var spacing = {
  SPACING_2: '2px',
  SPACING_4: '4px',
  SPACING_8: '8px',
  SPACING_12: '12px',
  SPACING_16: '16px',
  SPACING_24: '24px',
  SPACING_32: '32px',
  SPACING_40: '40px',
  SPACING_48: '48px',
  SPACING_56: '56px',
  SPACING_64: '64px',
  SPACING_72: '72px'
};

var spacing$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': spacing
}, [spacing]);

/**
 * Yle Design System
 * v0.4.0
 */

var themeDark = {
  BACKGROUND: '#131415',
  BACKGROUND_VARIANT: '#1f2123',
  BACKGROUND_CONTROL: 'rgba(255, 255, 255, 0.59)',
  BACKGROUND_CONTROL_DISABLED: 'rgba(255, 255, 255, 0.21)',
  BACKGROUND_DIALOG: '#1f2123',
  BACKGROUND_DIALOG_OVERLAY: 'rgba(0, 0, 0, 0.83)',
  BACKGROUND_INPUT: '#131415',
  BACKGROUND_HIGHLIGHT: '#0b3f4b',
  BACKGROUND_INTERACTIVE: '#292b2d',
  BACKGROUND_INFO_PRIMARY: '#d8d9db',
  BACKGROUND_INFO_SECONDARY: '#292b2d',
  BACKGROUND_SUCCESS: '#03e592',
  BACKGROUND_ERROR: '#f5517a',
  BACKGROUND_WARNING: '#ff9c31',
  TEXT_DEFAULT: '#f8f9fa',
  TEXT_NEGATIVE: '#131415',
  TEXT_INPUT_PLACEHOLDER: '#949697',
  TEXT_HIGH_EMPHASIS: 'rgba(255, 255, 255, 0.85)',
  TEXT_MEDIUM_EMPHASIS: 'rgba(255, 255, 255, 0.71)',
  TEXT_DISABLED: 'rgba(255, 255, 255, 0.3)',
  ACTION_PRIMARY: '#f8f9fa',
  ACTION_PRIMARY_VARIANT: 'rgba(255, 255, 255, 0.71)',
  ACTION_SECONDARY: 'rgba(255, 255, 255, 0.08)',
  ACTION_SECONDARY_VARIANT: 'rgba(255, 255, 255, 0.17)',
  ACTION_DISABLED: 'rgba(255, 255, 255, 0.21)',
  FEEDBACK_HIGHLIGHT: '#29ccde',
  FEEDBACK_ERROR: '#f5517a',
  FEEDBACK_WARNING: '#ff9c31',
  FEEDBACK_SUCCESS: '#03e592',
  FEEDBACK_LIVE: '#e90e43',
  BORDER: '#f8f9fa',
  BORDER_DISABLED: 'rgba(255, 255, 255, 0.3)',
  BORDER_SEPARATOR: '#4a4f54',
  BORDER_PRIMARY_FOCUS: '#29ccde',
  BORDER_SECONDARY_FOCUS: '#f8f9fa',
  BORDER_FOCUS: '#f8f9fa'
};

var themeDark$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': themeDark
}, [themeDark]);

/**
 * Yle Design System
 * v0.4.0
 */

var themeDefault = {
  BACKGROUND: '#ffffff',
  BACKGROUND_VARIANT: '#f8f9fa',
  BACKGROUND_CONTROL: 'rgba(0, 0, 0, 0.41)',
  BACKGROUND_CONTROL_DISABLED: 'rgba(0, 0, 0, 0.15)',
  BACKGROUND_DIALOG: '#ffffff',
  BACKGROUND_DIALOG_OVERLAY: 'rgba(0, 0, 0, 0.41)',
  BACKGROUND_HIGHLIGHT: '#e8e9eb',
  BACKGROUND_INTERACTIVE: '#f1f2f4',
  BACKGROUND_INFO_PRIMARY: '#9fc8ee',
  BACKGROUND_INFO_SECONDARY: '#f1f2f4',
  BACKGROUND_SUCCESS: '#62f9c2',
  BACKGROUND_WARNING: '#ffce8b',
  BACKGROUND_ERROR: '#f99fb5',
  BACKGROUND_INPUT: '#ffffff',
  TEXT_DEFAULT: '#131415',
  TEXT_NEGATIVE: '#f8f9fa',
  TEXT_INPUT_PLACEHOLDER: '#4a4f54',
  TEXT_HIGH_EMPHASIS: 'rgba(0, 0, 0, 0.79)',
  TEXT_MEDIUM_EMPHASIS: 'rgba(0, 0, 0, 0.7)',
  TEXT_DISABLED: 'rgba(0, 0, 0, 0.29)',
  ACTION_PRIMARY: '#131415',
  ACTION_PRIMARY_VARIANT: 'rgba(0, 0, 0, 0.7)',
  ACTION_SECONDARY: 'rgba(0, 0, 0, 0.05)',
  ACTION_SECONDARY_VARIANT: 'rgba(0, 0, 0, 0.09)',
  ACTION_DISABLED: 'rgba(0, 0, 0, 0.15)',
  FEEDBACK_HIGHLIGHT: '#009cb5',
  FEEDBACK_ERROR: '#d10b3d',
  FEEDBACK_WARNING: '#f1722a',
  FEEDBACK_SUCCESS: '#058657',
  FEEDBACK_LIVE: '#e90e43',
  BORDER: '#131415',
  BORDER_DISABLED: 'rgba(0, 0, 0, 0.29)',
  BORDER_SEPARATOR: '#e8e9eb',
  BORDER_PRIMARY_FOCUS: '#009cb5',
  BORDER_SECONDARY_FOCUS: '#131415',
  BORDER_FOCUS: '#131415'
};

var themeDefault$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': themeDefault
}, [themeDefault]);

/**
 * Yle Design System
 * v0.4.0
 */

var themeLight = {
  BACKGROUND: '#ffffff',
  BACKGROUND_VARIANT: '#f8f9fa',
  BACKGROUND_CONTROL: 'rgba(0, 0, 0, 0.41)',
  BACKGROUND_CONTROL_DISABLED: 'rgba(0, 0, 0, 0.15)',
  BACKGROUND_DIALOG: '#ffffff',
  BACKGROUND_DIALOG_OVERLAY: 'rgba(0, 0, 0, 0.41)',
  BACKGROUND_HIGHLIGHT: '#e8e9eb',
  BACKGROUND_INTERACTIVE: '#f1f2f4',
  BACKGROUND_INFO_PRIMARY: '#9fc8ee',
  BACKGROUND_INFO_SECONDARY: '#f1f2f4',
  BACKGROUND_SUCCESS: '#62f9c2',
  BACKGROUND_WARNING: '#ffce8b',
  BACKGROUND_ERROR: '#f99fb5',
  BACKGROUND_INPUT: '#ffffff',
  TEXT_DEFAULT: '#131415',
  TEXT_NEGATIVE: '#f8f9fa',
  TEXT_INPUT_PLACEHOLDER: '#4a4f54',
  TEXT_HIGH_EMPHASIS: 'rgba(0, 0, 0, 0.79)',
  TEXT_MEDIUM_EMPHASIS: 'rgba(0, 0, 0, 0.7)',
  TEXT_DISABLED: 'rgba(0, 0, 0, 0.29)',
  ACTION_PRIMARY: '#131415',
  ACTION_PRIMARY_VARIANT: 'rgba(0, 0, 0, 0.7)',
  ACTION_SECONDARY: 'rgba(0, 0, 0, 0.05)',
  ACTION_SECONDARY_VARIANT: 'rgba(0, 0, 0, 0.09)',
  ACTION_DISABLED: 'rgba(0, 0, 0, 0.15)',
  FEEDBACK_HIGHLIGHT: '#009cb5',
  FEEDBACK_ERROR: '#d10b3d',
  FEEDBACK_WARNING: '#f1722a',
  FEEDBACK_SUCCESS: '#058657',
  FEEDBACK_LIVE: '#e90e43',
  BORDER: '#131415',
  BORDER_DISABLED: 'rgba(0, 0, 0, 0.29)',
  BORDER_SEPARATOR: '#e8e9eb',
  BORDER_PRIMARY_FOCUS: '#009cb5',
  BORDER_SECONDARY_FOCUS: '#131415',
  BORDER_FOCUS: '#131415'
};

var themeLight$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': themeLight
}, [themeLight]);

/**
 * Yle Design System
 * v0.4.0
 */

var typography = {
  OPEN_SANS_7XL_BOLD_FONT_SIZE: '56px',
  OPEN_SANS_7XL_BOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_7XL_BOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_7XL_BOLD_FONT_WEIGHT: 700,
  OPEN_SANS_7XL_BOLD_FONT_STYLE: 'normal',
  OPEN_SANS_7XL_BOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_7XL_BOLD_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_7XL_BOLD_LETTER_SPACING: 0,
  OPEN_SANS_7XL_BOLD_LINE_HEIGHT: '130%',
  OPEN_SANS_7XL_BOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_7XL_BOLD_PARAGRAPH_SPACING: '56px',
  OPEN_SANS_7XL_BOLD_TEXT_CASE: 'none',
  OPEN_SANS_7XL_EXTRABOLD_FONT_SIZE: '56px',
  OPEN_SANS_7XL_EXTRABOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_7XL_EXTRABOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_7XL_EXTRABOLD_FONT_WEIGHT: 800,
  OPEN_SANS_7XL_EXTRABOLD_FONT_STYLE: 'normal',
  OPEN_SANS_7XL_EXTRABOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_7XL_EXTRABOLD_FONT_STYLE_OLD: 'ExtraBold',
  OPEN_SANS_7XL_EXTRABOLD_LETTER_SPACING: 0,
  OPEN_SANS_7XL_EXTRABOLD_LINE_HEIGHT: '130%',
  OPEN_SANS_7XL_EXTRABOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_7XL_EXTRABOLD_PARAGRAPH_SPACING: '56px',
  OPEN_SANS_7XL_EXTRABOLD_TEXT_CASE: 'none',
  OPEN_SANS_6XL_BOLD_FONT_SIZE: '48px',
  OPEN_SANS_6XL_BOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_6XL_BOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_6XL_BOLD_FONT_WEIGHT: 700,
  OPEN_SANS_6XL_BOLD_FONT_STYLE: 'normal',
  OPEN_SANS_6XL_BOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_6XL_BOLD_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_6XL_BOLD_LETTER_SPACING: 0,
  OPEN_SANS_6XL_BOLD_LINE_HEIGHT: '130%',
  OPEN_SANS_6XL_BOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_6XL_BOLD_PARAGRAPH_SPACING: '48px',
  OPEN_SANS_6XL_BOLD_TEXT_CASE: 'none',
  OPEN_SANS_6XL_EXTRABOLD_FONT_SIZE: '48px',
  OPEN_SANS_6XL_EXTRABOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_6XL_EXTRABOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_6XL_EXTRABOLD_FONT_WEIGHT: 800,
  OPEN_SANS_6XL_EXTRABOLD_FONT_STYLE: 'normal',
  OPEN_SANS_6XL_EXTRABOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_6XL_EXTRABOLD_FONT_STYLE_OLD: 'ExtraBold',
  OPEN_SANS_6XL_EXTRABOLD_LETTER_SPACING: 0,
  OPEN_SANS_6XL_EXTRABOLD_LINE_HEIGHT: '130%',
  OPEN_SANS_6XL_EXTRABOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_6XL_EXTRABOLD_PARAGRAPH_SPACING: '48px',
  OPEN_SANS_6XL_EXTRABOLD_TEXT_CASE: 'none',
  OPEN_SANS_5XL_BOLD_FONT_SIZE: '40px',
  OPEN_SANS_5XL_BOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_5XL_BOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_5XL_BOLD_FONT_WEIGHT: 700,
  OPEN_SANS_5XL_BOLD_FONT_STYLE: 'normal',
  OPEN_SANS_5XL_BOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_5XL_BOLD_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_5XL_BOLD_LETTER_SPACING: 0,
  OPEN_SANS_5XL_BOLD_LINE_HEIGHT: '130%',
  OPEN_SANS_5XL_BOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_5XL_BOLD_PARAGRAPH_SPACING: '40px',
  OPEN_SANS_5XL_BOLD_TEXT_CASE: 'none',
  OPEN_SANS_5XL_EXTRABOLD_FONT_SIZE: '40px',
  OPEN_SANS_5XL_EXTRABOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_5XL_EXTRABOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_5XL_EXTRABOLD_FONT_WEIGHT: 800,
  OPEN_SANS_5XL_EXTRABOLD_FONT_STYLE: 'normal',
  OPEN_SANS_5XL_EXTRABOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_5XL_EXTRABOLD_FONT_STYLE_OLD: 'ExtraBold',
  OPEN_SANS_5XL_EXTRABOLD_LETTER_SPACING: 0,
  OPEN_SANS_5XL_EXTRABOLD_LINE_HEIGHT: '130%',
  OPEN_SANS_5XL_EXTRABOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_5XL_EXTRABOLD_PARAGRAPH_SPACING: '40px',
  OPEN_SANS_5XL_EXTRABOLD_TEXT_CASE: 'none',
  OPEN_SANS_4XL_BOLD_FONT_SIZE: '32px',
  OPEN_SANS_4XL_BOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_4XL_BOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_4XL_BOLD_FONT_WEIGHT: 700,
  OPEN_SANS_4XL_BOLD_FONT_STYLE: 'normal',
  OPEN_SANS_4XL_BOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_4XL_BOLD_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_4XL_BOLD_LETTER_SPACING: 0,
  OPEN_SANS_4XL_BOLD_LINE_HEIGHT: '140%',
  OPEN_SANS_4XL_BOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_4XL_BOLD_PARAGRAPH_SPACING: '32px',
  OPEN_SANS_4XL_BOLD_TEXT_CASE: 'none',
  OPEN_SANS_4XL_EXTRABOLD_FONT_SIZE: '32px',
  OPEN_SANS_4XL_EXTRABOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_4XL_EXTRABOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_4XL_EXTRABOLD_FONT_WEIGHT: 800,
  OPEN_SANS_4XL_EXTRABOLD_FONT_STYLE: 'normal',
  OPEN_SANS_4XL_EXTRABOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_4XL_EXTRABOLD_FONT_STYLE_OLD: 'ExtraBold',
  OPEN_SANS_4XL_EXTRABOLD_LETTER_SPACING: 0,
  OPEN_SANS_4XL_EXTRABOLD_LINE_HEIGHT: '140%',
  OPEN_SANS_4XL_EXTRABOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_4XL_EXTRABOLD_PARAGRAPH_SPACING: '32px',
  OPEN_SANS_4XL_EXTRABOLD_TEXT_CASE: 'none',
  OPEN_SANS_3XL_BOLD_FONT_SIZE: '28px',
  OPEN_SANS_3XL_BOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_3XL_BOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_3XL_BOLD_FONT_WEIGHT: 700,
  OPEN_SANS_3XL_BOLD_FONT_STYLE: 'normal',
  OPEN_SANS_3XL_BOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_3XL_BOLD_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_3XL_BOLD_LETTER_SPACING: 0,
  OPEN_SANS_3XL_BOLD_LINE_HEIGHT: '130%',
  OPEN_SANS_3XL_BOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_3XL_BOLD_PARAGRAPH_SPACING: '28px',
  OPEN_SANS_3XL_BOLD_TEXT_CASE: 'none',
  OPEN_SANS_3XL_EXTRABOLD_FONT_SIZE: '28px',
  OPEN_SANS_3XL_EXTRABOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_3XL_EXTRABOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_3XL_EXTRABOLD_FONT_WEIGHT: 800,
  OPEN_SANS_3XL_EXTRABOLD_FONT_STYLE: 'normal',
  OPEN_SANS_3XL_EXTRABOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_3XL_EXTRABOLD_FONT_STYLE_OLD: 'ExtraBold',
  OPEN_SANS_3XL_EXTRABOLD_LETTER_SPACING: 0,
  OPEN_SANS_3XL_EXTRABOLD_LINE_HEIGHT: '130%',
  OPEN_SANS_3XL_EXTRABOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_3XL_EXTRABOLD_PARAGRAPH_SPACING: '28px',
  OPEN_SANS_3XL_EXTRABOLD_TEXT_CASE: 'none',
  OPEN_SANS_2XL_FONT_SIZE: '24px',
  OPEN_SANS_2XL_TEXT_DECORATION: 'none',
  OPEN_SANS_2XL_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_2XL_FONT_WEIGHT: 400,
  OPEN_SANS_2XL_FONT_STYLE: 'normal',
  OPEN_SANS_2XL_FONT_STRETCH: 'normal',
  OPEN_SANS_2XL_FONT_STYLE_OLD: 'Regular',
  OPEN_SANS_2XL_LETTER_SPACING: 0,
  OPEN_SANS_2XL_LINE_HEIGHT: '140%',
  OPEN_SANS_2XL_PARAGRAPH_INDENT: 0,
  OPEN_SANS_2XL_PARAGRAPH_SPACING: '24px',
  OPEN_SANS_2XL_TEXT_CASE: 'none',
  OPEN_SANS_2XL_BOLD_FONT_SIZE: '24px',
  OPEN_SANS_2XL_BOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_2XL_BOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_2XL_BOLD_FONT_WEIGHT: 700,
  OPEN_SANS_2XL_BOLD_FONT_STYLE: 'normal',
  OPEN_SANS_2XL_BOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_2XL_BOLD_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_2XL_BOLD_LETTER_SPACING: 0,
  OPEN_SANS_2XL_BOLD_LINE_HEIGHT: '140%',
  OPEN_SANS_2XL_BOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_2XL_BOLD_PARAGRAPH_SPACING: '24px',
  OPEN_SANS_2XL_BOLD_TEXT_CASE: 'none',
  OPEN_SANS_2XL_EXTRABOLD_FONT_SIZE: '24px',
  OPEN_SANS_2XL_EXTRABOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_2XL_EXTRABOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_2XL_EXTRABOLD_FONT_WEIGHT: 800,
  OPEN_SANS_2XL_EXTRABOLD_FONT_STYLE: 'normal',
  OPEN_SANS_2XL_EXTRABOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_2XL_EXTRABOLD_FONT_STYLE_OLD: 'ExtraBold',
  OPEN_SANS_2XL_EXTRABOLD_LETTER_SPACING: 0,
  OPEN_SANS_2XL_EXTRABOLD_LINE_HEIGHT: '140%',
  OPEN_SANS_2XL_EXTRABOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_2XL_EXTRABOLD_PARAGRAPH_SPACING: '24px',
  OPEN_SANS_2XL_EXTRABOLD_TEXT_CASE: 'none',
  OPEN_SANS_XL_FONT_SIZE: '20px',
  OPEN_SANS_XL_TEXT_DECORATION: 'none',
  OPEN_SANS_XL_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_XL_FONT_WEIGHT: 400,
  OPEN_SANS_XL_FONT_STYLE: 'normal',
  OPEN_SANS_XL_FONT_STRETCH: 'normal',
  OPEN_SANS_XL_FONT_STYLE_OLD: 'Regular',
  OPEN_SANS_XL_LETTER_SPACING: 0,
  OPEN_SANS_XL_LINE_HEIGHT: '150%',
  OPEN_SANS_XL_PARAGRAPH_INDENT: 0,
  OPEN_SANS_XL_PARAGRAPH_SPACING: '20px',
  OPEN_SANS_XL_TEXT_CASE: 'none',
  OPEN_SANS_XL_BOLD_FONT_SIZE: '20px',
  OPEN_SANS_XL_BOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_XL_BOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_XL_BOLD_FONT_WEIGHT: 700,
  OPEN_SANS_XL_BOLD_FONT_STYLE: 'normal',
  OPEN_SANS_XL_BOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_XL_BOLD_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_XL_BOLD_LETTER_SPACING: 0,
  OPEN_SANS_XL_BOLD_LINE_HEIGHT: '150%',
  OPEN_SANS_XL_BOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_XL_BOLD_PARAGRAPH_SPACING: '20px',
  OPEN_SANS_XL_BOLD_TEXT_CASE: 'none',
  OPEN_SANS_L_FONT_SIZE: '18px',
  OPEN_SANS_L_TEXT_DECORATION: 'none',
  OPEN_SANS_L_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_L_FONT_WEIGHT: 400,
  OPEN_SANS_L_FONT_STYLE: 'normal',
  OPEN_SANS_L_FONT_STRETCH: 'normal',
  OPEN_SANS_L_FONT_STYLE_OLD: 'Regular',
  OPEN_SANS_L_LETTER_SPACING: 0,
  OPEN_SANS_L_LINE_HEIGHT: '150%',
  OPEN_SANS_L_PARAGRAPH_INDENT: 0,
  OPEN_SANS_L_PARAGRAPH_SPACING: '18px',
  OPEN_SANS_L_TEXT_CASE: 'none',
  OPEN_SANS_L_BOLD_FONT_SIZE: '18px',
  OPEN_SANS_L_BOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_L_BOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_L_BOLD_FONT_WEIGHT: 700,
  OPEN_SANS_L_BOLD_FONT_STYLE: 'normal',
  OPEN_SANS_L_BOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_L_BOLD_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_L_BOLD_LETTER_SPACING: 0,
  OPEN_SANS_L_BOLD_LINE_HEIGHT: '150%',
  OPEN_SANS_L_BOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_L_BOLD_PARAGRAPH_SPACING: '18px',
  OPEN_SANS_L_BOLD_TEXT_CASE: 'none',
  OPEN_SANS_M_FONT_SIZE: '16px',
  OPEN_SANS_M_TEXT_DECORATION: 'none',
  OPEN_SANS_M_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_M_FONT_WEIGHT: 400,
  OPEN_SANS_M_FONT_STYLE: 'normal',
  OPEN_SANS_M_FONT_STRETCH: 'normal',
  OPEN_SANS_M_FONT_STYLE_OLD: 'Regular',
  OPEN_SANS_M_LETTER_SPACING: 0,
  OPEN_SANS_M_LINE_HEIGHT: '150%',
  OPEN_SANS_M_PARAGRAPH_INDENT: 0,
  OPEN_SANS_M_PARAGRAPH_SPACING: '16px',
  OPEN_SANS_M_TEXT_CASE: 'none',
  OPEN_SANS_M_BOLD_FONT_SIZE: '16px',
  OPEN_SANS_M_BOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_M_BOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_M_BOLD_FONT_WEIGHT: 700,
  OPEN_SANS_M_BOLD_FONT_STYLE: 'normal',
  OPEN_SANS_M_BOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_M_BOLD_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_M_BOLD_LETTER_SPACING: 0,
  OPEN_SANS_M_BOLD_LINE_HEIGHT: '150%',
  OPEN_SANS_M_BOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_M_BOLD_PARAGRAPH_SPACING: '16px',
  OPEN_SANS_M_BOLD_TEXT_CASE: 'none',
  OPEN_SANS_M_AC_FONT_SIZE: '16px',
  OPEN_SANS_M_AC_TEXT_DECORATION: 'none',
  OPEN_SANS_M_AC_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_M_AC_FONT_WEIGHT: 400,
  OPEN_SANS_M_AC_FONT_STYLE: 'normal',
  OPEN_SANS_M_AC_FONT_STRETCH: 'normal',
  OPEN_SANS_M_AC_FONT_STYLE_OLD: 'Regular',
  OPEN_SANS_M_AC_LETTER_SPACING: '1%',
  OPEN_SANS_M_AC_LINE_HEIGHT: '150%',
  OPEN_SANS_M_AC_PARAGRAPH_INDENT: 0,
  OPEN_SANS_M_AC_PARAGRAPH_SPACING: '16px',
  OPEN_SANS_M_AC_TEXT_CASE: 'uppercase',
  OPEN_SANS_M_BOLD_AC_FONT_SIZE: '16px',
  OPEN_SANS_M_BOLD_AC_TEXT_DECORATION: 'none',
  OPEN_SANS_M_BOLD_AC_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_M_BOLD_AC_FONT_WEIGHT: 700,
  OPEN_SANS_M_BOLD_AC_FONT_STYLE: 'normal',
  OPEN_SANS_M_BOLD_AC_FONT_STRETCH: 'normal',
  OPEN_SANS_M_BOLD_AC_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_M_BOLD_AC_LETTER_SPACING: '1%',
  OPEN_SANS_M_BOLD_AC_LINE_HEIGHT: '150%',
  OPEN_SANS_M_BOLD_AC_PARAGRAPH_INDENT: 0,
  OPEN_SANS_M_BOLD_AC_PARAGRAPH_SPACING: '16px',
  OPEN_SANS_M_BOLD_AC_TEXT_CASE: 'uppercase',
  OPEN_SANS_S_FONT_SIZE: '14px',
  OPEN_SANS_S_TEXT_DECORATION: 'none',
  OPEN_SANS_S_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_S_FONT_WEIGHT: 400,
  OPEN_SANS_S_FONT_STYLE: 'normal',
  OPEN_SANS_S_FONT_STRETCH: 'normal',
  OPEN_SANS_S_FONT_STYLE_OLD: 'Regular',
  OPEN_SANS_S_LETTER_SPACING: 0,
  OPEN_SANS_S_LINE_HEIGHT: '150%',
  OPEN_SANS_S_PARAGRAPH_INDENT: 0,
  OPEN_SANS_S_PARAGRAPH_SPACING: '14px',
  OPEN_SANS_S_TEXT_CASE: 'none',
  OPEN_SANS_S_BOLD_FONT_SIZE: '14px',
  OPEN_SANS_S_BOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_S_BOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_S_BOLD_FONT_WEIGHT: 700,
  OPEN_SANS_S_BOLD_FONT_STYLE: 'normal',
  OPEN_SANS_S_BOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_S_BOLD_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_S_BOLD_LETTER_SPACING: 0,
  OPEN_SANS_S_BOLD_LINE_HEIGHT: '150%',
  OPEN_SANS_S_BOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_S_BOLD_PARAGRAPH_SPACING: '14px',
  OPEN_SANS_S_BOLD_TEXT_CASE: 'none',
  OPEN_SANS_S_AC_FONT_SIZE: '14px',
  OPEN_SANS_S_AC_TEXT_DECORATION: 'none',
  OPEN_SANS_S_AC_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_S_AC_FONT_WEIGHT: 400,
  OPEN_SANS_S_AC_FONT_STYLE: 'normal',
  OPEN_SANS_S_AC_FONT_STRETCH: 'normal',
  OPEN_SANS_S_AC_FONT_STYLE_OLD: 'Regular',
  OPEN_SANS_S_AC_LETTER_SPACING: '1%',
  OPEN_SANS_S_AC_LINE_HEIGHT: '150%',
  OPEN_SANS_S_AC_PARAGRAPH_INDENT: 0,
  OPEN_SANS_S_AC_PARAGRAPH_SPACING: '14px',
  OPEN_SANS_S_AC_TEXT_CASE: 'uppercase',
  OPEN_SANS_S_BOLD_AC_FONT_SIZE: '14px',
  OPEN_SANS_S_BOLD_AC_TEXT_DECORATION: 'none',
  OPEN_SANS_S_BOLD_AC_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_S_BOLD_AC_FONT_WEIGHT: 700,
  OPEN_SANS_S_BOLD_AC_FONT_STYLE: 'normal',
  OPEN_SANS_S_BOLD_AC_FONT_STRETCH: 'normal',
  OPEN_SANS_S_BOLD_AC_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_S_BOLD_AC_LETTER_SPACING: '1%',
  OPEN_SANS_S_BOLD_AC_LINE_HEIGHT: '150%',
  OPEN_SANS_S_BOLD_AC_PARAGRAPH_INDENT: 0,
  OPEN_SANS_S_BOLD_AC_PARAGRAPH_SPACING: '14px',
  OPEN_SANS_S_BOLD_AC_TEXT_CASE: 'uppercase',
  OPEN_SANS_XS_FONT_SIZE: '12px',
  OPEN_SANS_XS_TEXT_DECORATION: 'none',
  OPEN_SANS_XS_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_XS_FONT_WEIGHT: 400,
  OPEN_SANS_XS_FONT_STYLE: 'normal',
  OPEN_SANS_XS_FONT_STRETCH: 'normal',
  OPEN_SANS_XS_FONT_STYLE_OLD: 'Regular',
  OPEN_SANS_XS_LETTER_SPACING: 0,
  OPEN_SANS_XS_LINE_HEIGHT: '150%',
  OPEN_SANS_XS_PARAGRAPH_INDENT: 0,
  OPEN_SANS_XS_PARAGRAPH_SPACING: '12px',
  OPEN_SANS_XS_TEXT_CASE: 'none',
  OPEN_SANS_XS_BOLD_FONT_SIZE: '12px',
  OPEN_SANS_XS_BOLD_TEXT_DECORATION: 'none',
  OPEN_SANS_XS_BOLD_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_XS_BOLD_FONT_WEIGHT: 700,
  OPEN_SANS_XS_BOLD_FONT_STYLE: 'normal',
  OPEN_SANS_XS_BOLD_FONT_STRETCH: 'normal',
  OPEN_SANS_XS_BOLD_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_XS_BOLD_LETTER_SPACING: 0,
  OPEN_SANS_XS_BOLD_LINE_HEIGHT: '150%',
  OPEN_SANS_XS_BOLD_PARAGRAPH_INDENT: 0,
  OPEN_SANS_XS_BOLD_PARAGRAPH_SPACING: '12px',
  OPEN_SANS_XS_BOLD_TEXT_CASE: 'none',
  OPEN_SANS_XS_AC_FONT_SIZE: '12px',
  OPEN_SANS_XS_AC_TEXT_DECORATION: 'none',
  OPEN_SANS_XS_AC_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_XS_AC_FONT_WEIGHT: 400,
  OPEN_SANS_XS_AC_FONT_STYLE: 'normal',
  OPEN_SANS_XS_AC_FONT_STRETCH: 'normal',
  OPEN_SANS_XS_AC_FONT_STYLE_OLD: 'Regular',
  OPEN_SANS_XS_AC_LETTER_SPACING: '1%',
  OPEN_SANS_XS_AC_LINE_HEIGHT: '150%',
  OPEN_SANS_XS_AC_PARAGRAPH_INDENT: 0,
  OPEN_SANS_XS_AC_PARAGRAPH_SPACING: '12px',
  OPEN_SANS_XS_AC_TEXT_CASE: 'uppercase',
  OPEN_SANS_XS_BOLD_AC_FONT_SIZE: '12px',
  OPEN_SANS_XS_BOLD_AC_TEXT_DECORATION: 'none',
  OPEN_SANS_XS_BOLD_AC_FONT_FAMILY: 'Open Sans',
  OPEN_SANS_XS_BOLD_AC_FONT_WEIGHT: 700,
  OPEN_SANS_XS_BOLD_AC_FONT_STYLE: 'normal',
  OPEN_SANS_XS_BOLD_AC_FONT_STRETCH: 'normal',
  OPEN_SANS_XS_BOLD_AC_FONT_STYLE_OLD: 'Bold',
  OPEN_SANS_XS_BOLD_AC_LETTER_SPACING: '1%',
  OPEN_SANS_XS_BOLD_AC_LINE_HEIGHT: '150%',
  OPEN_SANS_XS_BOLD_AC_PARAGRAPH_INDENT: 0,
  OPEN_SANS_XS_BOLD_AC_PARAGRAPH_SPACING: '12px',
  OPEN_SANS_XS_BOLD_AC_TEXT_CASE: 'uppercase',
  YLE_SANS_7XL_BLACK_FONT_SIZE: '56px',
  YLE_SANS_7XL_BLACK_TEXT_DECORATION: 'none',
  YLE_SANS_7XL_BLACK_FONT_FAMILY: 'Yle',
  YLE_SANS_7XL_BLACK_FONT_WEIGHT: 900,
  YLE_SANS_7XL_BLACK_FONT_STYLE: 'normal',
  YLE_SANS_7XL_BLACK_FONT_STRETCH: 'normal',
  YLE_SANS_7XL_BLACK_FONT_STYLE_OLD: 'Black',
  YLE_SANS_7XL_BLACK_LETTER_SPACING: 0,
  YLE_SANS_7XL_BLACK_LINE_HEIGHT: '120%',
  YLE_SANS_7XL_BLACK_PARAGRAPH_INDENT: 0,
  YLE_SANS_7XL_BLACK_PARAGRAPH_SPACING: '56px',
  YLE_SANS_7XL_BLACK_TEXT_CASE: 'none',
  YLE_SANS_6XL_BLACK_FONT_SIZE: '48px',
  YLE_SANS_6XL_BLACK_TEXT_DECORATION: 'none',
  YLE_SANS_6XL_BLACK_FONT_FAMILY: 'Yle',
  YLE_SANS_6XL_BLACK_FONT_WEIGHT: 900,
  YLE_SANS_6XL_BLACK_FONT_STYLE: 'normal',
  YLE_SANS_6XL_BLACK_FONT_STRETCH: 'normal',
  YLE_SANS_6XL_BLACK_FONT_STYLE_OLD: 'Black',
  YLE_SANS_6XL_BLACK_LETTER_SPACING: 0,
  YLE_SANS_6XL_BLACK_LINE_HEIGHT: '120%',
  YLE_SANS_6XL_BLACK_PARAGRAPH_INDENT: 0,
  YLE_SANS_6XL_BLACK_PARAGRAPH_SPACING: '48px',
  YLE_SANS_6XL_BLACK_TEXT_CASE: 'none',
  YLE_SANS_5XL_BLACK_FONT_SIZE: '40px',
  YLE_SANS_5XL_BLACK_TEXT_DECORATION: 'none',
  YLE_SANS_5XL_BLACK_FONT_FAMILY: 'Yle',
  YLE_SANS_5XL_BLACK_FONT_WEIGHT: 900,
  YLE_SANS_5XL_BLACK_FONT_STYLE: 'normal',
  YLE_SANS_5XL_BLACK_FONT_STRETCH: 'normal',
  YLE_SANS_5XL_BLACK_FONT_STYLE_OLD: 'Black',
  YLE_SANS_5XL_BLACK_LETTER_SPACING: 0,
  YLE_SANS_5XL_BLACK_LINE_HEIGHT: '120%',
  YLE_SANS_5XL_BLACK_PARAGRAPH_INDENT: 0,
  YLE_SANS_5XL_BLACK_PARAGRAPH_SPACING: '40px',
  YLE_SANS_5XL_BLACK_TEXT_CASE: 'none',
  YLE_SANS_4XL_BOLD_FONT_SIZE: '32px',
  YLE_SANS_4XL_BOLD_TEXT_DECORATION: 'none',
  YLE_SANS_4XL_BOLD_FONT_FAMILY: 'Yle',
  YLE_SANS_4XL_BOLD_FONT_WEIGHT: 700,
  YLE_SANS_4XL_BOLD_FONT_STYLE: 'normal',
  YLE_SANS_4XL_BOLD_FONT_STRETCH: 'normal',
  YLE_SANS_4XL_BOLD_FONT_STYLE_OLD: 'Bold',
  YLE_SANS_4XL_BOLD_LETTER_SPACING: 0,
  YLE_SANS_4XL_BOLD_LINE_HEIGHT: '120%',
  YLE_SANS_4XL_BOLD_PARAGRAPH_INDENT: 0,
  YLE_SANS_4XL_BOLD_PARAGRAPH_SPACING: '32px',
  YLE_SANS_4XL_BOLD_TEXT_CASE: 'none',
  YLE_SANS_4XL_BLACK_FONT_SIZE: '32px',
  YLE_SANS_4XL_BLACK_TEXT_DECORATION: 'none',
  YLE_SANS_4XL_BLACK_FONT_FAMILY: 'Yle',
  YLE_SANS_4XL_BLACK_FONT_WEIGHT: 900,
  YLE_SANS_4XL_BLACK_FONT_STYLE: 'normal',
  YLE_SANS_4XL_BLACK_FONT_STRETCH: 'normal',
  YLE_SANS_4XL_BLACK_FONT_STYLE_OLD: 'Black',
  YLE_SANS_4XL_BLACK_LETTER_SPACING: 0,
  YLE_SANS_4XL_BLACK_LINE_HEIGHT: '120%',
  YLE_SANS_4XL_BLACK_PARAGRAPH_INDENT: 0,
  YLE_SANS_4XL_BLACK_PARAGRAPH_SPACING: '32px',
  YLE_SANS_4XL_BLACK_TEXT_CASE: 'none',
  YLE_SANS_3XL_BOLD_FONT_SIZE: '28px',
  YLE_SANS_3XL_BOLD_TEXT_DECORATION: 'none',
  YLE_SANS_3XL_BOLD_FONT_FAMILY: 'Yle',
  YLE_SANS_3XL_BOLD_FONT_WEIGHT: 700,
  YLE_SANS_3XL_BOLD_FONT_STYLE: 'normal',
  YLE_SANS_3XL_BOLD_FONT_STRETCH: 'normal',
  YLE_SANS_3XL_BOLD_FONT_STYLE_OLD: 'Bold',
  YLE_SANS_3XL_BOLD_LETTER_SPACING: 0,
  YLE_SANS_3XL_BOLD_LINE_HEIGHT: '130%',
  YLE_SANS_3XL_BOLD_PARAGRAPH_INDENT: 0,
  YLE_SANS_3XL_BOLD_PARAGRAPH_SPACING: '28px',
  YLE_SANS_3XL_BOLD_TEXT_CASE: 'none',
  YLE_SANS_3XL_BLACK_FONT_SIZE: '28px',
  YLE_SANS_3XL_BLACK_TEXT_DECORATION: 'none',
  YLE_SANS_3XL_BLACK_FONT_FAMILY: 'Yle',
  YLE_SANS_3XL_BLACK_FONT_WEIGHT: 900,
  YLE_SANS_3XL_BLACK_FONT_STYLE: 'normal',
  YLE_SANS_3XL_BLACK_FONT_STRETCH: 'normal',
  YLE_SANS_3XL_BLACK_FONT_STYLE_OLD: 'Black',
  YLE_SANS_3XL_BLACK_LETTER_SPACING: 0,
  YLE_SANS_3XL_BLACK_LINE_HEIGHT: '130%',
  YLE_SANS_3XL_BLACK_PARAGRAPH_INDENT: 0,
  YLE_SANS_3XL_BLACK_PARAGRAPH_SPACING: '28px',
  YLE_SANS_3XL_BLACK_TEXT_CASE: 'none',
  YLE_SANS_2XL_BOLD_FONT_SIZE: '24px',
  YLE_SANS_2XL_BOLD_TEXT_DECORATION: 'none',
  YLE_SANS_2XL_BOLD_FONT_FAMILY: 'Yle',
  YLE_SANS_2XL_BOLD_FONT_WEIGHT: 700,
  YLE_SANS_2XL_BOLD_FONT_STYLE: 'normal',
  YLE_SANS_2XL_BOLD_FONT_STRETCH: 'normal',
  YLE_SANS_2XL_BOLD_FONT_STYLE_OLD: 'Bold',
  YLE_SANS_2XL_BOLD_LETTER_SPACING: 0,
  YLE_SANS_2XL_BOLD_LINE_HEIGHT: '130%',
  YLE_SANS_2XL_BOLD_PARAGRAPH_INDENT: 0,
  YLE_SANS_2XL_BOLD_PARAGRAPH_SPACING: '24px',
  YLE_SANS_2XL_BOLD_TEXT_CASE: 'none',
  YLE_SANS_2XL_BLACK_FONT_SIZE: '24px',
  YLE_SANS_2XL_BLACK_TEXT_DECORATION: 'none',
  YLE_SANS_2XL_BLACK_FONT_FAMILY: 'Yle',
  YLE_SANS_2XL_BLACK_FONT_WEIGHT: 900,
  YLE_SANS_2XL_BLACK_FONT_STYLE: 'normal',
  YLE_SANS_2XL_BLACK_FONT_STRETCH: 'normal',
  YLE_SANS_2XL_BLACK_FONT_STYLE_OLD: 'Black',
  YLE_SANS_2XL_BLACK_LETTER_SPACING: 0,
  YLE_SANS_2XL_BLACK_LINE_HEIGHT: '130%',
  YLE_SANS_2XL_BLACK_PARAGRAPH_INDENT: 0,
  YLE_SANS_2XL_BLACK_PARAGRAPH_SPACING: '24px',
  YLE_SANS_2XL_BLACK_TEXT_CASE: 'none',
  YLE_SANS_XL_BOLD_FONT_SIZE: '20px',
  YLE_SANS_XL_BOLD_TEXT_DECORATION: 'none',
  YLE_SANS_XL_BOLD_FONT_FAMILY: 'Yle',
  YLE_SANS_XL_BOLD_FONT_WEIGHT: 700,
  YLE_SANS_XL_BOLD_FONT_STYLE: 'normal',
  YLE_SANS_XL_BOLD_FONT_STRETCH: 'normal',
  YLE_SANS_XL_BOLD_FONT_STYLE_OLD: 'Bold',
  YLE_SANS_XL_BOLD_LETTER_SPACING: 0,
  YLE_SANS_XL_BOLD_LINE_HEIGHT: '140%',
  YLE_SANS_XL_BOLD_PARAGRAPH_INDENT: 0,
  YLE_SANS_XL_BOLD_PARAGRAPH_SPACING: '20px',
  YLE_SANS_XL_BOLD_TEXT_CASE: 'none',
  YLE_SANS_L_BOLD_FONT_SIZE: '18px',
  YLE_SANS_L_BOLD_TEXT_DECORATION: 'none',
  YLE_SANS_L_BOLD_FONT_FAMILY: 'Yle',
  YLE_SANS_L_BOLD_FONT_WEIGHT: 700,
  YLE_SANS_L_BOLD_FONT_STYLE: 'normal',
  YLE_SANS_L_BOLD_FONT_STRETCH: 'normal',
  YLE_SANS_L_BOLD_FONT_STYLE_OLD: 'Bold',
  YLE_SANS_L_BOLD_LETTER_SPACING: 0,
  YLE_SANS_L_BOLD_LINE_HEIGHT: '140%',
  YLE_SANS_L_BOLD_PARAGRAPH_INDENT: 0,
  YLE_SANS_L_BOLD_PARAGRAPH_SPACING: '18px',
  YLE_SANS_L_BOLD_TEXT_CASE: 'none',
  YLE_SANS_XL_BLACK_FONT_SIZE: '20px',
  YLE_SANS_XL_BLACK_TEXT_DECORATION: 'none',
  YLE_SANS_XL_BLACK_FONT_FAMILY: 'Yle',
  YLE_SANS_XL_BLACK_FONT_WEIGHT: 900,
  YLE_SANS_XL_BLACK_FONT_STYLE: 'normal',
  YLE_SANS_XL_BLACK_FONT_STRETCH: 'normal',
  YLE_SANS_XL_BLACK_FONT_STYLE_OLD: 'Black',
  YLE_SANS_XL_BLACK_LETTER_SPACING: 0,
  YLE_SANS_XL_BLACK_LINE_HEIGHT: '140%',
  YLE_SANS_XL_BLACK_PARAGRAPH_INDENT: 0,
  YLE_SANS_XL_BLACK_PARAGRAPH_SPACING: '20px',
  YLE_SANS_XL_BLACK_TEXT_CASE: 'none',
  YLE_SANS_L_BLACK_FONT_SIZE: '18px',
  YLE_SANS_L_BLACK_TEXT_DECORATION: 'none',
  YLE_SANS_L_BLACK_FONT_FAMILY: 'Yle',
  YLE_SANS_L_BLACK_FONT_WEIGHT: 900,
  YLE_SANS_L_BLACK_FONT_STYLE: 'normal',
  YLE_SANS_L_BLACK_FONT_STRETCH: 'normal',
  YLE_SANS_L_BLACK_FONT_STYLE_OLD: 'Black',
  YLE_SANS_L_BLACK_LETTER_SPACING: 0,
  YLE_SANS_L_BLACK_LINE_HEIGHT: '140%',
  YLE_SANS_L_BLACK_PARAGRAPH_INDENT: 0,
  YLE_SANS_L_BLACK_PARAGRAPH_SPACING: '18px',
  YLE_SANS_L_BLACK_TEXT_CASE: 'none',
  YLE_SANS_M_BOLD_FONT_SIZE: '16px',
  YLE_SANS_M_BOLD_TEXT_DECORATION: 'none',
  YLE_SANS_M_BOLD_FONT_FAMILY: 'Yle',
  YLE_SANS_M_BOLD_FONT_WEIGHT: 700,
  YLE_SANS_M_BOLD_FONT_STYLE: 'normal',
  YLE_SANS_M_BOLD_FONT_STRETCH: 'normal',
  YLE_SANS_M_BOLD_FONT_STYLE_OLD: 'Bold',
  YLE_SANS_M_BOLD_LETTER_SPACING: 0,
  YLE_SANS_M_BOLD_LINE_HEIGHT: '140%',
  YLE_SANS_M_BOLD_PARAGRAPH_INDENT: 0,
  YLE_SANS_M_BOLD_PARAGRAPH_SPACING: '16px',
  YLE_SANS_M_BOLD_TEXT_CASE: 'none',
  YLE_SANS_S_BOLD_FONT_SIZE: '14px',
  YLE_SANS_S_BOLD_TEXT_DECORATION: 'none',
  YLE_SANS_S_BOLD_FONT_FAMILY: 'Yle',
  YLE_SANS_S_BOLD_FONT_WEIGHT: 700,
  YLE_SANS_S_BOLD_FONT_STYLE: 'normal',
  YLE_SANS_S_BOLD_FONT_STRETCH: 'normal',
  YLE_SANS_S_BOLD_FONT_STYLE_OLD: 'Bold',
  YLE_SANS_S_BOLD_LETTER_SPACING: 0,
  YLE_SANS_S_BOLD_LINE_HEIGHT: '140%',
  YLE_SANS_S_BOLD_PARAGRAPH_INDENT: 0,
  YLE_SANS_S_BOLD_PARAGRAPH_SPACING: '14px',
  YLE_SANS_S_BOLD_TEXT_CASE: 'none'
};

var typography$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': typography
}, [typography]);

/**
 * Yle Design System
 * v0.4.0
 */

var typographyTokens = {
  FONT_SIZE_7XL: '56px',
  FONT_SIZE_6XL: '48px',
  FONT_SIZE_5XL: '40px',
  FONT_SIZE_4XL: '32px',
  FONT_SIZE_3XL: '28px',
  FONT_SIZE_2XL: '24px',
  FONT_SIZE_XL: '20px',
  FONT_SIZE_LG: '18px',
  FONT_SIZE_MD: '16px',
  FONT_SIZE_SM: '14px',
  FONT_SIZE_XS: '12px',
  FONT_WEIGHT_BLACK: 900,
  FONT_WEIGHT_EXTRA_BOLD: 800,
  FONT_WEIGHT_BOLD: 700,
  FONT_WEIGHT_NORMAL: 400,
  LINE_HEIGHT_120: '120%',
  LINE_HEIGHT_130: '130%',
  LINE_HEIGHT_140: '140%',
  LINE_HEIGHT_150: '150%',
  FONT_FAMILY_YLE: 'Yle',
  FONT_FAMILY_OPEN_SANS: 'Open Sans',
  TEXT_DECORATION_DEFAULT: 'none',
  FONT_STYLE_DEFAULT: 'normal',
  TEXT_CASE_DEFAULT: 'normal',
  TEXT_CASE_UPPERCASE: 'uppercase',
  LETTER_SPACING_MD: 0,
  LETTER_SPACING_LG: '0.01em'
};

var typographyTokens$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': typographyTokens
}, [typographyTokens]);

/**
 * Yle Design System
 * v0.4.0
 */

var colorsPolitical = {
  PARTY_KESK: '#209e3a',
  PARTY_PS: '#00c2ef',
  PARTY_KOK: '#005cb7',
  PARTY_SDP: '#ff3333',
  PARTY_VIHR: '#6bd12a',
  PARTY_VAS: '#9a003d',
  PARTY_RKP: '#f9b800',
  PARTY_KD: '#7946e8',
  PARTY_SIN: '#002c7a',
  PARTY_FEM: '#ff4097',
  PARTY_LIIK: '#af0079',
  PARTY_KTP: '#640020',
  PARTY_LIB: '#f95900',
  PARTY_PIR: '#191919',
  PARTY_MUUT: '#9cacb5',
  POLITICAL_ALIGNMENT_FAR_LEFT: '#6d162e',
  POLITICAL_ALIGNMENT_LEFT: '#cb1428',
  POLITICAL_ALIGNMENT_MID_LEFT: '#f195a9',
  POLITICAL_ALIGNMENT_MID_RIGHT: '#6bb6e1',
  POLITICAL_ALIGNMENT_RIGHT: '#1877bc',
  POLITICAL_ALIGNMENT_FAR_RIGHT: '#223361'
};

var colorsPolitical$1 = /*#__PURE__*/_mergeNamespaces({
  __proto__: null,
  'default': colorsPolitical
}, [colorsPolitical]);

export { border$1 as border, colors$1 as color, shadowDark$1 as darkShadow, themeDark$1 as darkTheme, shadowDefault$1 as defaultShadow, themeDefault$1 as defaultTheme, shadowLight$1 as lightShadow, themeLight$1 as lightTheme, colorsPolitical$1 as politicalColors, borderRadius$1 as radius, spacing$1 as spacing, typography$1 as typography, typographyTokens$1 as typographyTokens };
